import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

function Sidebar() {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    streaming: true,
    content: true,
    engagement: true,
    analytics: true,
    system: true,
    settings: false
  });

  const isAdmin = user?.role === 'admin';
  const isOBS = user?.role === 'obs';

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const closeSidebar = () => setIsOpen(false);

  const NavSection = ({ id, label, children }) => (
    <div className="nav-section">
      <div className="section-header" onClick={() => toggleSection(id)}>
        <span className="section-title">{label}</span>
        <span className="section-arrow">{expandedSections[id] ? '▲' : '▼'}</span>
      </div>
      {expandedSections[id] && (
        <div className="section-content">{children}</div>
      )}
    </div>
  );

  const SidebarContent = () => (
    <>
      <div className="sidebar-header">
        <div className="sidebar-title-row">
          <h1>⚡ Nexus Control v2</h1>
          <button className="close-btn" onClick={closeSidebar}>✕</button>
        </div>
        <div className="user-info">
          <span className="username">{user?.username}</span>
          {isAdmin && <span className="user-role">Admin</span>}
          {isOBS && <span className="user-role">OBS</span>}
          <button onClick={logout} className="logout-btn" title="Abmelden">🚪</button>
        </div>
      </div>

      <div className="sidebar-nav">
        <NavLink to="/" end onClick={closeSidebar}>
          <span className="nav-icon">📊</span> Übersicht
        </NavLink>

        {!isOBS && (
          <>
            <NavSection id="streaming" label="Streaming">
              <NavLink to="/dashboard" onClick={closeSidebar}><span className="nav-icon">🎛️</span> Dashboard</NavLink>
              <NavLink to="/obs" onClick={closeSidebar}><span className="nav-icon">🎥</span> OBS Control</NavLink>
              <NavLink to="/obs-presets" onClick={closeSidebar}><span className="nav-icon">🎬</span> OBS Presets</NavLink>
              <NavLink to="/srtla" onClick={closeSidebar}><span className="nav-icon">📡</span> SRTLA Monitor</NavLink>
              <NavLink to="/rtmp" onClick={closeSidebar}><span className="nav-icon">🎯</span> Multistream</NavLink>
            </NavSection>

            <NavSection id="content" label="Content">
              <NavLink to="/commands" onClick={closeSidebar}><span className="nav-icon">⚡</span> Commands</NavLink>
              <NavLink to="/chat-timers" onClick={closeSidebar}><span className="nav-icon">⏱️</span> Chat-Timer</NavLink>
              <NavLink to="/modules" onClick={closeSidebar}><span className="nav-icon">🎲</span> Module</NavLink>
              <NavLink to="/checkpoints" onClick={closeSidebar}><span className="nav-icon">📍</span> Checkpoints</NavLink>
            </NavSection>

            <NavSection id="engagement" label="Engagement">
              <NavLink to="/chat" onClick={closeSidebar}><span className="nav-icon">💬</span> Chat</NavLink>
              <NavLink to="/alerts" onClick={closeSidebar}><span className="nav-icon">🎬</span> Alerts</NavLink>
              <NavLink to="/chat-alerts" onClick={closeSidebar}><span className="nav-icon">💬</span> Chat Alerts</NavLink>
              <NavLink to="/donations" onClick={closeSidebar}><span className="nav-icon">💰</span> Donations</NavLink>
              <NavLink to="/goals" onClick={closeSidebar}><span className="nav-icon">🎯</span> Sub-Ziele</NavLink>
            </NavSection>

            <NavSection id="analytics" label="Analytics">
              <NavLink to="/stats" onClick={closeSidebar}><span className="nav-icon">📊</span> Stats</NavLink>
              <NavLink to="/feedback" onClick={closeSidebar}><span className="nav-icon">🐛</span> Feedback</NavLink>
            </NavSection>

            <NavSection id="system" label="System">
              <NavLink to="/console" onClick={closeSidebar}><span className="nav-icon">🖥️</span> Console</NavLink>
              <NavLink to="/nexus" onClick={closeSidebar}><span className="nav-icon">🤖</span> Nexus AI</NavLink>
              {isAdmin && <NavLink to="/users" onClick={closeSidebar}><span className="nav-icon">👥</span> Benutzer</NavLink>}
              {isAdmin && <NavLink to="/permissions" onClick={closeSidebar}><span className="nav-icon">🔐</span> Berechtigungen</NavLink>}
            </NavSection>

            <NavSection id="settings" label="Settings">
              <NavLink to="/settings/twitch-main" onClick={closeSidebar}><span className="nav-icon">💜</span> Twitch Main</NavLink>
              <NavLink to="/settings/twitch-247" onClick={closeSidebar}><span className="nav-icon">🔄</span> Twitch 24/7</NavLink>
              <NavLink to="/settings/youtube" onClick={closeSidebar}><span className="nav-icon">▶️</span> YouTube</NavLink>
              <NavLink to="/settings/discord" onClick={closeSidebar}><span className="nav-icon">💙</span> Discord</NavLink>
              <NavLink to="/settings/streamelements" onClick={closeSidebar}><span className="nav-icon">⭐</span> StreamElements</NavLink>
              <NavLink to="/settings/paypal" onClick={closeSidebar}><span className="nav-icon">💳</span> PayPal</NavLink>
              <NavLink to="/settings/obs-presets" onClick={closeSidebar}><span className="nav-icon">🎬</span> OBS Presets</NavLink>
            </NavSection>
          </>
        )}

        {isOBS && (
          <NavLink to="/obs" onClick={closeSidebar}><span className="nav-icon">🎥</span> OBS Control</NavLink>
        )}
      </div>
    </>
  );

  return (
    <>
      {/* Mobile hamburger - only visible on mobile */}
      <button className="mobile-menu-toggle" onClick={() => setIsOpen(true)}>☰</button>

      {/* Desktop sidebar */}
      <nav className="sidebar desktop-sidebar">
        <SidebarContent />
      </nav>

      {/* Mobile sidebar + overlay */}
      {isOpen && (
        <div className="mobile-sidebar-wrapper">
          <div className="mobile-overlay" onClick={closeSidebar} />
          <nav className="sidebar mobile-sidebar open">
            <SidebarContent />
          </nav>
        </div>
      )}
    </>
  );
}

export default Sidebar;
